import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SidebarLiveDragContext = /*#__PURE__*/createContext(null);

function propsMatchSettledDrag(allItems, liveDrag) {
  var inCurrent = allItems.filter(function (item) {
    return item.sectionId === liveDrag.currentSectionId;
  });
  var indexInCurrent = inCurrent.findIndex(function (item) {
    return item.id.toString() === liveDrag.itemId;
  });

  if (indexInCurrent < 0) {
    return false;
  }

  if (liveDrag.originalSectionId === liveDrag.currentSectionId) {
    return indexInCurrent === liveDrag.currentIndex;
  }

  var stillInSource = allItems.some(function (item) {
    return item.id.toString() === liveDrag.itemId && item.sectionId === liveDrag.originalSectionId;
  });
  return !stillInSource;
}

export var SidebarLiveDragProvider = function SidebarLiveDragProvider(_ref) {
  var children = _ref.children,
      allItems = _ref.allItems;

  var _useState = useState(null),
      liveDrag = _useState[0],
      setLiveDrag = _useState[1];

  var liveDragRef = useRef(liveDrag);
  liveDragRef.current = liveDrag;
  var allItemsRef = useRef(allItems);
  allItemsRef.current = allItems;
  var commitHandlerRef = useRef(null);
  var committedQuestionIdRef = useRef(null);
  var resolveItem = useCallback(function (id) {
    return allItemsRef.current.find(function (item) {
      return item.id.toString() === id;
    });
  }, []);
  var registerCrossSectionCommit = useCallback(function (handler) {
    commitHandlerRef.current = handler;
  }, []);
  var beginLiveDrag = useCallback(function (state) {
    committedQuestionIdRef.current = null;

    var next = _objectSpread(_objectSpread({}, state), {}, {
      phase: 'dragging'
    });

    liveDragRef.current = next;
    setLiveDrag(next);
  }, []);
  var previewInSection = useCallback(function (sectionId, index) {
    setLiveDrag(function (prev) {
      if (!prev || prev.phase === 'settled') return prev;

      if (prev.currentSectionId === sectionId && prev.currentIndex === index) {
        return prev;
      }

      var next = _objectSpread(_objectSpread({}, prev), {}, {
        currentSectionId: sectionId,
        currentIndex: index
      });

      liveDragRef.current = next;
      return next;
    });
  }, []);
  var settleLiveDrag = useCallback(function () {
    setLiveDrag(function (prev) {
      if (!prev) return prev;

      var next = _objectSpread(_objectSpread({}, prev), {}, {
        phase: 'settled'
      });

      liveDragRef.current = next;
      return next;
    });
  }, []);
  var endLiveDrag = useCallback(function () {
    committedQuestionIdRef.current = null;
    liveDragRef.current = null;
    setLiveDrag(null);
  }, []);
  var commitCrossSectionMove = useCallback(function (args) {
    var _commitHandlerRef$cur;

    if (!args.questionId || !args.targetSectionId || !args.sourceSectionId) {
      return false;
    }

    if (args.sourceSectionId === args.targetSectionId) {
      return false;
    }

    if (committedQuestionIdRef.current === args.questionId) {
      return false;
    }

    committedQuestionIdRef.current = args.questionId; // Keep optimistic placement locked to the commit target.

    setLiveDrag(function (prev) {
      var base = prev || {
        itemId: args.questionId,
        originalSectionId: args.sourceSectionId,
        currentSectionId: args.targetSectionId,
        currentIndex: args.targetIndex,
        item: resolveItem(args.questionId),
        phase: 'dragging'
      };

      if (!base.item) {
        return prev;
      }

      var next = _objectSpread(_objectSpread({}, base), {}, {
        currentSectionId: args.targetSectionId,
        currentIndex: args.targetIndex,
        phase: 'settled'
      });

      liveDragRef.current = next;
      return next;
    });
    (_commitHandlerRef$cur = commitHandlerRef.current) === null || _commitHandlerRef$cur === void 0 ? void 0 : _commitHandlerRef$cur.call(commitHandlerRef, args);
    return true;
  }, [resolveItem]);
  useEffect(function () {
    var active = liveDragRef.current;

    if (!active || active.phase !== 'settled') {
      return;
    }

    if (propsMatchSettledDrag(allItems, active)) {
      committedQuestionIdRef.current = null;
      liveDragRef.current = null;
      setLiveDrag(null);
    }
  }, [allItems]);
  var value = useMemo(function () {
    return {
      liveDrag: liveDrag,
      liveDragRef: liveDragRef,
      beginLiveDrag: beginLiveDrag,
      previewInSection: previewInSection,
      settleLiveDrag: settleLiveDrag,
      endLiveDrag: endLiveDrag,
      resolveItem: resolveItem,
      registerCrossSectionCommit: registerCrossSectionCommit,
      commitCrossSectionMove: commitCrossSectionMove
    };
  }, [liveDrag, beginLiveDrag, previewInSection, settleLiveDrag, endLiveDrag, resolveItem, registerCrossSectionCommit, commitCrossSectionMove]);
  return /*#__PURE__*/_jsx(SidebarLiveDragContext.Provider, {
    value: value,
    children: children
  });
};
export var useSidebarLiveDrag = function useSidebarLiveDrag() {
  var ctx = useContext(SidebarLiveDragContext);

  if (!ctx) {
    var noopRef = {
      current: null
    };
    return {
      liveDrag: null,
      liveDragRef: noopRef,
      beginLiveDrag: function beginLiveDrag() {
        return undefined;
      },
      previewInSection: function previewInSection() {
        return undefined;
      },
      settleLiveDrag: function settleLiveDrag() {
        return undefined;
      },
      endLiveDrag: function endLiveDrag() {
        return undefined;
      },
      resolveItem: function resolveItem() {
        return undefined;
      },
      registerCrossSectionCommit: function registerCrossSectionCommit() {
        return undefined;
      },
      commitCrossSectionMove: function commitCrossSectionMove() {
        return false;
      }
    };
  }

  return ctx;
};
/**
 * Build the list shown while a cross-section (or same-section) drag is active.
 */

export function applySidebarLiveDragToList(sectionId, baseItems, liveDrag) {
  if (!liveDrag) {
    return baseItems;
  }

  var withoutDragged = baseItems.filter(function (item) {
    return item.id.toString() !== liveDrag.itemId;
  });

  if (liveDrag.currentSectionId === sectionId) {
    var insertAt = Math.min(Math.max(liveDrag.currentIndex, 0), withoutDragged.length);

    var next = _toConsumableArray(withoutDragged);

    next.splice(insertAt, 0, liveDrag.item);
    return next;
  }

  if (liveDrag.originalSectionId === sectionId) {
    if (liveDrag.phase === 'settled') {
      return withoutDragged;
    } // Keep the HTML5 drag source mounted in the origin section.


    return baseItems;
  }

  return withoutDragged;
}
export function getSidebarLiveDragRowRole(sectionId, itemId, liveDrag) {
  if (!liveDrag || liveDrag.itemId !== itemId || liveDrag.phase === 'settled') {
    return 'normal';
  }

  if (liveDrag.currentSectionId === sectionId && liveDrag.originalSectionId !== sectionId) {
    return 'ghost';
  }

  return 'normal';
}